export default {
  text: 'black',
  primary: '#292f75',
  secondary: '#9bb2c7',
  background: 'white',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#020303',
}
